// 登录
import service from '@/utils/request'

// 社团列表
export function sxhList(data) {
    return service({
        url: '/service/admin/businessassociation_list',
        method: 'post',
        params: data
    })
}
// 社团审核操作
export function setapply(data) {
    return service({
        url: '/service/admin/businessassociation_setapply',
        method: 'post',
        params: data
    })
}
// 社团详情
export function shangxiehuixiangqing(data) {
    return service({
        url: '/service/admin/businessassociation_view',
        method: 'post',
        params: data
    })
}
// setstatus
export function setstatus(data) {
    return service({
        url: '/service/admin/businessassociation_setstatus',
        method: 'post',
        params: data
    })
}
// 社团置顶记录
export function istoprecord(data) {
    return service({
        url: '/service/admin/businessassociation_istoprecord',
        method: 'post',
        params: data
    })
}
// busidel
export function busidel(data) {
    return service({
        url: '/service/admin/businessassociation_del',
        method: 'post',
        params: data
    })
}

// 成员列表
export function businessassociation_members(data) {
    return service({
        url: '/service/admin/businessassociation_members',
        method: 'post',
        params: data
    })
}

// 成员审核
export function businessassociation_member_audit(data) {
    return service({
        url: '/service/admin/businessassociation_member_audit',
        method: 'post',
        params: data
    })
}

// 成员申请列表
export function businessassociation_members_applying(data) {
    return service({
        url: '/service/admin/business_apply_list',
        method: 'post',
        params: data
    })
}

/** 协会活动类别列表*/
export function getBusinessSportTypeList(data) {
  return service({
    url: '/service/admin/businessSportTypeList',
    method: 'post',
    params: data
  })
}

/** 协会活动场地列表*/
export function getBusinessSportSiteList(data) {
  return service({
    url: '/service/admin/site_list',
    method: 'post',
    params: data
  })
}

/** 协会成员编辑状态*/
export function businessassociationMemberEdit(data) {
  return service({
    url: '/service/admin/businessassociation_member_edit',
    method: 'post',
    params: data
  })
}

/** 重置协会密码*/
export function resetPassWithAssocition(data) {
  return service({
    url: "/service/admin/business_reset_password",
    method: "post",
    data,
  });
}
